import React from 'react';
import {Card} from 'antd';
import InputComponent from '../../../atoms/Inputs/Input';
import styles from './style.module.css';

interface FormProps {
    email: string;
    required: boolean;
    onEmailChange: (value: string) => void;
    onSubmit: (event: React.FormEvent) => Promise<void>;
}

const ResetPasswordForm: React.FC<FormProps> = ({email, required, onEmailChange}) => {
    return (
        <Card title={<span style={{color: '#1677ff', fontWeight: 'bold', fontSize: '30px'}}>Request password reset</span>}
        >
            <form className={styles.resetPasswordForm}>
                <div>
                    <InputComponent label={'Email'} value={email} placeholder={''} type={'email'} labelPosition={'up'}
                                    required={required} onChange={onEmailChange}/>
                </div>
            </form>
        </Card>
    );
};

export default ResetPasswordForm;
